module.exports = __webpack_public_path__ + "img/zep1.fd4347a5.jpg";